import React from "react";
import { MarkerType } from "react-flow-renderer";

import { Link } from "react-router-dom";

const level1 = "rgb(17, 3, 3, 0.1)";
const level2 = "rgb(0, 25, 59, 0.9)";
const level3 = "rgb(0, 25, 59, 0.9)";
const level4 = "#003379";
const level5 = "#0a0f17";
const level6 = "#de723a";
const black = "yellow";
const white = "white";

export const nodes = [
  {
    id: "1",
    type: "input",
    data: {
      label: (
        <>
          <strong>Examples</strong>
        </>
      ),
    },
    position: { x: 0, y: 0 },
    style: {
      background: level1,
      color: white,
      border: "1px solid #222138",
      width: 180,
    },
  },

  {
    id: "2",

    data: {
      label: (
        <>
          <strong>Polish webpages with CSS</strong>
          <div className="basic-css-code"></div>
        </>
      ),
    },
    position: { x: -1144, y: 200 },
    style: {
      background: level2,
      color: white,
      border: "1px solid #222138",
      width: 600,
    },
  },

  {
    id: "3",

    data: {
      label: (
        <>
          <strong>Before</strong>
          <iframe
            height="800"
            width="100%"
            scrolling="no"
            title="Yuri Site"
            src="https://codepen.io/jonathanelias1/embed/preview/WNJYyML?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/WNJYyML">
              Yuri Site
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -1740, y: 500 },
    style: {
      background: level4,
      color: white,
      border: "10px solid #003377",
      width: 800,
    },
  },

  {
    id: "4",

    data: {
      label: (
        <>
          <strong>After</strong>
          <iframe
            height="800"
            width="100%"
            scrolling="no"
            title="Yuri Site After"
            src="https://codepen.io/jonathanelias1/embed/preview/NWMEzze?default-tab=result&editable=true"
            frameBorder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/NWMEzze">
              Yuri Site After
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: -738, y: 500 },
    style: {
      background: level4,
      margin: 0,
      color: white,
      border: "10px solid #003377",
      width: 800,
    },
  },

  {
    id: "5",

    data: {
      label: (
        <>
          <strong>Cool Examples</strong>
          <p></p>
        </>
      ),
    },
    position: { x: 660, y: 200 },
    style: {
      background: level3,
      margin: 0,
      color: white,
      border: "1px solid #003377",
      width: 300,
    },
  },

  {
    id: "6",

    data: {
      label: (
        <>
          <strong>Gradient Text</strong>
          <iframe
            height="600"
            width="100%"
            scrolling="no"
            title="gradient color"
            src="https://codepen.io/jonathanelias1/embed/preview/yLjzqQo?default-tab=result&editable=true"
            frameborder="no"
            loading="lazy"
            allowtransparency="true"
            allowFullScreen={true}
          >
            See the Pen{" "}
            <a href="https://codepen.io/jonathanelias1/pen/yLjzqQo">
              gradient color
            </a>{" "}
            by Jonathan Elias (
            <a href="https://codepen.io/jonathanelias1">@jonathanelias1</a>) on{" "}
            <a href="https://codepen.io">CodePen</a>.
          </iframe>
        </>
      ),
    },
    position: { x: 408, y: 564 },
    style: {
      background: level4,
      color: black,
      border: "1px solid #222138",
      width: 800,
    },
  },

  // End of items
];

export const edges = [
  {
    id: "e1-2",
    source: "1",
    target: "2",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e1-5",
    source: "1",
    target: "5",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //Polish HTML with CSS
  {
    id: "e2-3",
    source: "2",
    target: "3",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  {
    id: "e2-4",
    source: "2",
    target: "4",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //Cool examples

  {
    id: "e5-6",
    source: "5",
    target: "6",
    // label: "this is an edge label",
    markerEnd: {
      type: MarkerType.ArrowClosed,
    },
  },

  //   {
  //     id: "e8-10",
  //     source: "8",
  //     target: "10",
  //     animated: true,
  //     style: { stroke: "#f6ab6c" },
  //     markerEnd: {
  //       type: MarkerType.ArrowClosed,
  //     },
  //   },

  //END
];
